import parse from 'html-react-parser';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import axios from '../../../services/MyAxios';

import { CRM_PERMISSION } from '../Helpers/CrmPermissions';

import { CASINO_FREESPIN_PAGES, CASINO_FREESPIN_PAGES_EDIT } from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

import ActionButton from 'crm/elements/ActionButton';

function FreespinPageShow() {
    const [bonusPage, setBonusPage] = useState({
        title: '',
        slug: '',
        text: '',
        language_id: 0,
        translation_id: 0,
        image_path: '',
    });
    const [languages, setLanguages] = useState([]);
    const [translations, setTranslations] = useState([]);
    const history = useHistory();
    const { id } = useParams();
    const url = `/crea/casino/api/freespin-pages/${id}`;

    useEffect(() => {
        getFreespinPage();
        getLanguages();
        getTranslations();
    }, []);

    function getFreespinPage() {
        axios
            .get(url)
            .then((response) => {
                const responseData = response.data;
                setBonusPage(responseData);
            })
            .catch(() => {
                history.push({
                    pathname: CASINO_FREESPIN_PAGES,
                });
            });
    }

    function getLanguages() {
        axios.get('/crea/api/languages').then((response) => {
            setLanguages(response.data);
        });
    }

    function getTranslations() {
        axios.get('/crea/casino/api/freespin-pages/translations').then((response) => {
            setTranslations(response.data);
        });
    }

    return (
        <div className="card">
            <div className="card-header">Page bonus details</div>
            <div className="card-body table-responsive">
                <table className="table">
                    <thead />
                    <tbody>
                        <tr key="title">
                            <th width="30%">Title</th>
                            <td>{bonusPage.title}</td>
                        </tr>
                        <tr key="slug">
                            <th width="30%">Slug</th>
                            <td>{bonusPage.slug}</td>
                        </tr>
                        <tr key="language_id">
                            <th width="30%">Language</th>
                            <td>{languages.map((lang) => lang.id === bonusPage.language_id && lang.name)}</td>
                        </tr>
                        <tr key="translation_id">
                            <th width="30%">This is translation of</th>
                            <td>
                                {translations.map(
                                    (translation) => translation.id === bonusPage.translation_id && translation.title
                                )}
                            </td>
                        </tr>
                        <tr key="text">
                            <th width="30%">Text</th>
                            <td>{parse(bonusPage.text)}</td>
                        </tr>
                        <tr key="image">
                            <th width="30%">Image</th>
                            <td>
                                <img
                                    style={{ maxWidth: '100%', width: '200px' }}
                                    src={bonusPage.image_path}
                                    alt={bonusPage.title}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ActionButton
                    url={replaceUrlParams(CASINO_FREESPIN_PAGES_EDIT, { id })}
                    title="Edit bonus page"
                    permissions={[CRM_PERMISSION.FREESPIN_PAGE_EDIT]}
                />
            </div>
        </div>
    );
}

export default FreespinPageShow;
